import EditVideoContainer from "../containers/EditVideoContainer";

const EditVideoPage = () => {
  return (
    <EditVideoContainer />
  );
};

export default EditVideoPage;
